import { Component, OnInit } from '@angular/core';
import { Tracker } from '../../models/tracker';
import { TrackerPair } from '../../models/trackerpair';
import { TrackerService } from '../../services/tracker.service';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { Gym } from '../../models/gym';
import { GymService } from '../../services/gym.service';
import * as trackerSides from '../../config/TrackerSide';

@Component({
  selector: 'app-tracker-pair',
  templateUrl: './tracker-pair.component.html',
  styleUrls: ['./tracker-pair.component.scss']
})

export class TrackerPairComponent implements OnInit {

  public listOfTrackerPair: Array<TrackerPair>;
  public ErrorMsg = '';
  public editMode: boolean;

  public editingPair: TrackerPair;

  public listOfTrackers: Array<any> = [];
  public leftTrackersAvailable: Array<Tracker> = [];
  public rightTrackersAvailable: Array<Tracker> = [];
  public listOfUsers: Array<User> = [];
  public listOfGyms: Array<Gym>;
  public storage: any;
  displayableIds: Array<number> = [];

  constructor(private trackerService: TrackerService, private userService: UserService, private gymService: GymService) {
    for (let i = 1; i <= 20; i++ ) {
      this.displayableIds.push(i);
    }
  }

  ngOnInit() {
    this.storage = window.localStorage;
    this.editMode = false;
    this.editingPair = new TrackerPair();
    this.editingPair.leftTracker = new Tracker();
    this.editingPair.rightTracker = new Tracker();
    this.editingPair.gym = new Gym();
    this.listOfTrackerPair = [];
    this.leftTrackersAvailable = [];
    this.rightTrackersAvailable = [];

    this.gymService.getAllGyms().then((gyms) => {
      this.listOfGyms = gyms;
      this.trackerService.getAvailableForUseTrackers().then((listOfAllTrackers) => {
        this.listOfTrackers = listOfAllTrackers;
        listOfAllTrackers.forEach(tracker => {
            if (tracker.side === trackerSides.TRACKER_LEFT) {
              this.leftTrackersAvailable.push(tracker);
            } else {
              this.rightTrackersAvailable.push(tracker);
            }
        });
        this.userService.getAllUsers().then((listOfUsers) => {
          this.listOfUsers = listOfUsers;
        });
        this.getTrackerPairs();
      });
    });
  }

  getTrackerPairs() {
    this.trackerService.getAllTrackerPair().then((listOfPairs) => {
      this.listOfTrackerPair = listOfPairs;
    });
  }

  addTrackerPair() {
    this.editingPair.leftTracker = this.editingPair.leftTracker._id;
    this.editingPair.rightTracker = this.editingPair.rightTracker._id;

    if (this.editingPair.displayableId && this.editingPair.leftTracker && this.editingPair.rightTracker) {
      this.trackerService.addTrackerPair(this.editingPair).subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Pair ID, trackers, gym are required.';
    }
  }

  delTrackerPair(trackerPair) {
    this.trackerService.delTrackerPair(trackerPair._id).subscribe((res) => {
      this.ngOnInit();
    });
  }

  setUsedBy() {
    if (this.editingPair.usedBy._id) {
      this.listOfUsers.some((user) => {
        if (user._id === this.editingPair.usedBy._id) {
          this.editingPair.usedBy = user;
          return true;
        }
      });
    } else {
      this.editingPair.usedBy = new User();
    }
  }

  setGym() {
    this.listOfGyms.some((gym) => {
      if (gym._id === this.editingPair.gym._id) {
        this.editingPair.gym = gym;
        return true;
      }
    });
  }

  setTrackerPairToEdit(trackerPair) {
    this.editMode = true;
    this.leftTrackersAvailable.push(trackerPair.leftTracker);
    this.rightTrackersAvailable.push(trackerPair.rightTracker);
    this.editingPair = trackerPair;
    if (this.editingPair.usedBy === null) {
      this.editingPair.usedBy = new User();
    }
    if (this.editingPair.gym === null) {
      this.editingPair.gym = new Gym();
    }
  }

  editTrackerPair() {
    const updatedTrackerPair: any = {};
    updatedTrackerPair._id = this.editingPair._id;
    updatedTrackerPair.displayableId = this.editingPair.displayableId;
    updatedTrackerPair.gym = this.editingPair.gym._id;
    updatedTrackerPair.leftTracker = this.editingPair.leftTracker._id;
    updatedTrackerPair.rightTracker = this.editingPair.rightTracker._id;
    updatedTrackerPair.usedBy = this.editingPair.usedBy._id ? this.editingPair.usedBy._id : null;
    this.trackerService.editTrackerPair(updatedTrackerPair._id, updatedTrackerPair).subscribe(() => {
      this.ngOnInit();
    });
  }

  quitEditingMode() {
    this.editMode = false;
    this.leftTrackersAvailable.splice(this.leftTrackersAvailable.indexOf(this.editingPair.leftTracker), 1);
    this.rightTrackersAvailable.splice(this.rightTrackersAvailable.indexOf(this.editingPair.rightTracker), 1);
    this.editingPair = new TrackerPair();
    this.editingPair.leftTracker = new Tracker();
    this.editingPair.rightTracker = new Tracker();
    this.editingPair.usedBy = null;
    this.editingPair.gym = new Gym();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/tracker-pair/tracker-pair.component.ts